import { env } from '../env'
import axios, { type AxiosResponse } from 'axios'
import SHA256 from 'crypto-js/sha256'
import encHex from 'crypto-js/enc-hex'
import api from '../utils/api'

const apiUrl = env.REACT_APP_SUMMARIZATION_API_URL
const passwordKey = env.REACT_APP_SUMMARIZATION_API_KEY

export function sha256Password (password: string): string {
  return SHA256(password).toString(encHex)
}

const commentsSummarization = async (comments: string[]): Promise<any> => {
  const digestHex = sha256Password(passwordKey)
  const payload = JSON.stringify({
    commentSummarizationPassword: digestHex,
    comments
  })

  const res = await axios.post(apiUrl, payload,
    {
      headers: { 'Content-Type': 'text/plain' },
      withCredentials: false
    }
  )
  return res
}

export const getFlaggedComments = async (params: { termId: string, distributionSeriesId: string, sectionId: string }): Promise<AxiosResponse> => {
  return await api.get('/api/flagged_comments/', { params })
}

export const getFlaggedCommentsCDG = async (params: any): Promise<AxiosResponse> => {
  return await api.get('/api/flagged_comments/', {
    headers: {
      Accept: 'application/cdg'
    },
    params
  })
}

export const updateFlaggedComments = async (data: any): Promise<AxiosResponse> => {
  return await api.post(
    `/api/flagged_comments/${data.sectionId}`,
    data,
    {
      params: { termId: data.termId, distributionSeriesId: data.distributionSeriesId }
    }
  )
}

export const deleteFlaggedComment = async (commentId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/flagged_comments/${commentId}`)
}

const exportSavedCommentsCSV = async (): Promise<AxiosResponse> => {
  return await api.get('/api/flagged_comments/export/')
}

export default {
  updateFlaggedComments,
  commentsSummarization,
  getFlaggedComments,
  deleteFlaggedComment,
  getFlaggedCommentsCDG,
  exportSavedCommentsCSV
}
